const cookieBannerTranslations = new Map([
  ['Cookie consent', 'Küpsiste nõusolek'],
  [
    'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our',
    'Meie ja meie partnerid, sealhulgas Shopify, kasutame küpsiseid ja muid tehnoloogiaid teie kasutuskogemuse isikupärastamiseks, reklaamide kuvamiseks ja analüütikaks. Me ei kasuta neid selleks ilma teie nõusolekuta. Lisateavet leiate meie',
  ],
  ['Privacy Policy', 'privaatsuspoliitikast'],
  ['Manage preferences', 'Halda eelistusi'],
  ['Accept', 'Nõustu'],
  ['Decline', 'Keeldu'],
  ['Cookie and privacy preferences', 'Küpsiste ja privaatsuse eelistused'],
  ['Accept all', 'Nõustu kõigiga'],
  ['Decline all', 'Keeldu kõigist'],
  ['Save my choices', 'Salvesta minu valikud'],
  ['You control your data', 'Teie otsustate, kuidas teie andmeid kasutatakse'],
  [
    'Learn more about the cookies we use, and choose which cookies to allow.',
    'Tutvuge kasutatavate küpsistega ja valige, milliseid neist lubada.',
  ],
  ['If you accept all cookies', 'Kui lubate kõik küpsised'],
  ['Our site may be improved based on your interests', 'Saame täiustada saiti teie huvide põhjal'],
  [
    'Your preferences may be stored for when you return',
    'Teie eelistused võidakse järgmiseks külastuseks salvestada',
  ],
  ["You may see advertising that's tailored to you", 'Võite näha teile kohandatud reklaame'],
  ['Required', 'Vajalikud'],
  [
    'These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.',
    'Need küpsised on vajalikud saidi nõuetekohaseks toimimiseks, sealhulgas sisselogimiseks ja toodete ostukorvi lisamiseks.',
  ],
  ['Analytics', 'Analüütika'],
  [
    'These cookies help us understand how you interact with the site. We use this data to identify areas to improve.',
    'Need küpsised aitavad meil mõista, kuidas te saiti kasutate. Kasutame neid andmeid parendusvõimaluste leidmiseks.',
  ],
  ['Personalization', 'Isikupärastamine'],
  [
    'These cookies store details about your actions to personalize your next visit to the website.',
    'Need küpsised salvestavad teavet teie tegevuste kohta, et isikupärastada järgmist veebisaidi külastust.',
  ],
  ['Marketing', 'Turundus'],
  [
    'These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.',
    'Neid küpsiseid kasutame meie ja meie partnerid, sealhulgas Shopify, turunduskommunikatsiooni täiustamiseks ja reklaamide kuvamiseks teistel veebisaitidel.',
  ],
]);

function replaceTextNode(node) {
  const original = node.nodeValue ?? '';
  const translated = cookieBannerTranslations.get(original.trim());
  if (!translated) return;

  const leadingWhitespace = original.match(/^\s*/)?.[0] ?? '';
  const trailingWhitespace = original.match(/\s*$/)?.[0] ?? '';
  node.nodeValue = `${leadingWhitespace}${translated}${trailingWhitespace}`;
}

function translateCookieBanner() {
  for (const container of document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      replaceTextNode(node);
      node = walker.nextNode();
    }

    for (const policyLink of container.querySelectorAll('a[href*="/policies/privacy-policy"]')) {
      policyLink.setAttribute('href', '/policies/privacy-policy');
    }
  }
}

let translationScheduled = false;
const observer = new MutationObserver(() => {
  if (translationScheduled) return;
  translationScheduled = true;

  queueMicrotask(() => {
    translationScheduled = false;
    translateCookieBanner();
  });
});

translateCookieBanner();
observer.observe(document.body, { childList: true, subtree: true });
